import React from "react";
import { LandingPageTemplate } from "../ui/templates/LandingPageTemplate";

const IndexPage = () => {
	return <LandingPageTemplate />;
};

export default IndexPage;
